import axios from "utils/axios";
import { WellnessHeaders } from "utils/wellness";

class TeamService {
  getAllTeams(name, sort) {
    if (name) {
      var filterData = {
        "filter[name]": name,
      };
    }

    if (sort) {
      var sortData = {
        order_by: sort.orderBy,
        order: sort.order,
      };
    }

    return axios.get("user/teams", {
      params: {
        ...filterData,
        ...sortData,
      },
    });
  }

  async getTeam(team_id) {
    const response = await axios.get("user/teams", {
      params: {
        team_id,
      },
    });
    return response;
  }

  async getInvites(page = 1) {
    try {
      const response = await axios.get("/user/team/invitations/pending", {
        params: {
          page,
        },
      });

      return response;
    } catch (error) {
      Promise.resolve(0);
    }
  }

  getSlackPath(team_id) {
    return axios.get(`/user/team/${team_id}/slack/auth`);
  }

  getUserSlackInformation(team_id) {
    return axios.get(`/user/team/${team_id}/slack`);
  }

  deleteUserSlackInformation(team_id) {
    return axios.delete(`/user/team/${team_id}/slack`);
  }

  deleteCompanyPostExpression(companyId, postId, expressionId) {
    return axios.delete(
      `/company/${companyId}/post/${postId}/expression/${expressionId}`
    );
  }

  deletePostExpression(teamId, postId, expressionId) {
    return axios.delete(
      `/user/team/${teamId}/post/${postId}/expression/${expressionId}`
    );
  }

  deleteAccount(password) {
    return axios.delete("/delete-account", {
      data: { password: password },
    });
  }

  deleteListItemExpression(teamId, listId, todoItemId, expressionId) {
    return axios.delete(
      `user/team/${teamId}/todo-list/${listId}/todo-list-item/${todoItemId}/expression/${expressionId}`
    );
  }

  rejectTeamInvitation(invitation_code, reason) {
    const reject_reason = reason;
    return axios.post("/user/team/invitations/reject", {
      invitation_code,
      reject_reason,
    });
  }

  postLevelEngagement(team_id, level_of_engagement_id) {
    return axios.post(`/user/team/${team_id}/level-of-engagement`, {
      level_of_engagement_id: level_of_engagement_id,
    });
  }

  acceptTeamInvitation(invitation_code) {
    return axios.post("/user/team/join", {
      invitation_code,
    });
  }

  postTeamLeave(team_id) {
    return axios.post(`/user/team/${team_id}/leave`);
  }

  joinTeam(invitation_code) {
    return axios.post("user/team/join", {
      invitation_code,
    });
  }

  inviteMembers(team_id, emails = []) {
    return axios.post(`user/team/${team_id}/invite`, {
      emails,
    });
  }

  postWaterCooler(
    team_id,
    private_watercooler,
    post_id,
    tag_users,
    waterCoolerStatus
  ) {
    let data2 = {};

    if (post_id && private_watercooler === "true") {
      data2.team_post_id = post_id;
    }

    if (tag_users) {
      data2.tag_users = tag_users;
    }

    let data = {
      action: "create",
    };
    if (waterCoolerStatus) {
      data.action = "join";
    }

    return axios.post(
      `user/team/${team_id}/watercooler/access?action=${data.action}`,
      data2
    );
  }

  postWebhookMicrosoftTeamUrl(team_id, url, type_id = 1) {
    var data = {
      incoming_webhook_url: url,
      type_id: type_id,
    };

    return axios.post(`user/team/${team_id}/external-webhooks`, data);
  }

  updateWebhookMicrosoftTeamUrl(team_id, url, type_id = 1, webhook_id = 3) {
    var data = {
      incoming_webhook_url: url,
      type_id: type_id,
    };

    return axios.put(`user/team/${team_id}/external-webhooks/${webhook_id}`, {
      ...data,
    });
  }

  getWebhookMicrosoftTeamsUrl(team_id) {
    return axios.get(`user/team/${team_id}/external-webhooks`);
  }

  getWebhooks(team_id) {
    return axios.get(`user/team/${team_id}/ringcentral/incoming-webhook-url`);
  }

  postWebhookUrl(team_id, url) {
    var data = {
      incoming_webhook_url: url,
    };

    return axios.post(
      `user/team/${team_id}/ringcentral/incoming-webhook-url`,
      data
    );
  }

  updateWebhookUrl(team_id, url) {
    var data = {
      incoming_webhook_url: url,
    };

    return axios.put(
      `user/team/${team_id}/ringcentral/incoming-webhook-url`,
      data
    );
  }

  getMembers(team_id) {
    return axios.get(`user/team/${team_id}/members`);
  }

  getListLevelOfEngagement() {
    return axios.get(`user/team/level-of-engagement`);
  }

  getTeamLevelEngagement(team_id) {
    return axios.get(`user/team/${team_id}/level-of-engagement`);
  }

  getTeamProfile(team_id) {
    return axios.get(`user/team/${team_id}/profile`);
  }

  postTeamProfile(team_id, media, team_name, notification_alert) {
    let formData = new FormData();

    if (media !== null) {
      formData.append("avatar", media);
    }

    if (team_name !== null) {
      formData.append("name", team_name);
    }

    if (notification_alert !== null) {
      formData.append("notification_alert", notification_alert ? 1 : 0);
    }

    return axios.post(`user/team/${team_id}/profile`, formData);
  }

  createTeam(name) {
    return axios.post("user/team", {
      name,
    });
  }

  deletePost(team_id, post_id) {
    return axios.delete(`user/team/${team_id}/posts/${post_id}`);
  }

  deleteWebhookUrl(team_id) {
    return axios.delete(
      `user/team/${team_id}/ringcentral/incoming-webhook-url`
    );
  }

  deleteMicrosoftTeamsWebhook(team_id, webhook_id) {
    return axios.delete(`user/team/${team_id}/external-webhooks/${webhook_id}`);
  }

  deleteTodolistTask(team_id, list_id, listTask_id) {
    return axios.delete(
      `user/team/${team_id}/todo-list/${list_id}/todo-list-item/${listTask_id}`
    );
  }

  deleteTeam(team_id) {
    return axios.delete(`user/team/${team_id}`);
  }

  removeTeamMember(team_id, member_id) {
    return axios.delete(`user/team/${team_id}/member/${member_id}`);
  }

  getTimeline(team_id, page, type = null, sort = null, filter = null) {
    const types = {
      celebration: 8,
      brightidea: 9,
    };

    if (sort) {
      var data = {
        order_by: sort.order_by,
        order: sort.order,
      };
    }

    if (filter) {
      var filterData = {
        ...(filter?.type_id.length !== 0 && {
          "filter[type_id]": filter?.type_id?.join(","),
        }),
        ...(filter?.selectMembers.length !== 0 && {
          "filter[user_id]": filter?.selectMembers
            ?.map((member) => member.id)
            .join(","),
        }),
        ...(filter?.taggedMembers.length !== 0 && {
          "filter[tagged_user_id]": filter?.taggedMembers
            ?.map((member) => member.id)
            .join(","),
        }),
        ...(filter?.date_from && { "filter[date_from]": filter?.date_from }),
        ...(filter?.date_to && { "filter[date_to]": filter?.date_to }),
      };
    }

    return axios.get(`/user/team/${team_id}/timeline`, {
      params: {
        page,
        type_id: types[type] ?? null,
        ...data,
        ...filterData,
      },
    });
  }

  createWelcomeMessage(team_id, payload) {
    var data = {
      media: payload.media,
    };

    if (payload.attachment.type.includes("image")) {
      data.media_type = "photo";
      data.media_type_id = 2;
    } else if (payload.attachment.type.includes("audio")) {
      data.media_type = "audio";
      data.media_type_id = 4;
    } else if (payload.attachment.type.includes("video")) {
      data.media_type = "video";
      data.media_type_id = 3;
    }

    return axios.post(`/user/team/${team_id}/welcome-message`, data);
  }

  latestRecognition(team_id) {
    return axios.get(
      `/user/team/${team_id}/post/recent-celebration-recognition`
    );
  }

  markWelcomeMessageAsRead(team_id, is_read = 1) {
    return axios.post(`/user/team/${team_id}/read-welcome-message`, {
      is_read,
    });
  }

  createTeamVideo(team_id, topic, media) {
    return axios.post(`/user/team/${team_id}/video`, {
      topic,
      media,
    });
  }

  createSlideShow(team_id, topic, content, media) {
    let formData = new FormData();
    formData.append("media", media);
    formData.append("topic", topic);
    formData.append("content", content);

    return axios.post(`/user/team/${team_id}/slideshow`, formData);
  }

  getTeamVideo(team_id, video) {
    return axios.get(`/user/team/${team_id}/video/${video}`);
  }

  getTeamVideoResponse(team_id, video) {
    return axios.get(`/user/team/${team_id}/videos/${video}`);
  }

  getTeamVideos(team_id, from_date, page) {
    return axios.get(`/user/team/${team_id}/videos`, {
      params: {
        from_date,
        page,
      },
    });
  }

  getBuzzlistCompanyPost(company_id, post_id) {
    return axios.get(`/company/${company_id}/post/${post_id}/buzz`);
  }

  getBuzzlistPost(team_id, post_id) {
    return axios.get(`/user/team/${team_id}/post/${post_id}/buzz`);
  }

  getCompanyCommentBuzzlist(company_id, post_id, expression_id) {
    return axios.get(
      `/company/${company_id}/post/${post_id}/expression/${expression_id}/buzz`
    );
  }


  getCommentBuzzlist(team_id, post_id, expression_id) {
    return axios.get(
      `/user/team/${team_id}/post/${post_id}/expression/${expression_id}/buzz`
    );
  }

  getListCommentBuzzlist(team_id, list_id, expression_id) {
    return axios.get(
      `/user/team/${team_id}/todo-list-item/${list_id}/expression/${expression_id}/buzz`
    );
  }

  getBuzzlistsTodo(team_id, list_id, list_task_id) {
    return axios.get(
      `/user/team/${team_id}/todo-list/${list_id}/todo-list-item/${list_task_id}/buzz`
    );
  }

  postTeamVideoResponse(team_id, video, media, caption) {
    let formData = new FormData();
    formData.append("media", media);
    formData.append("caption", caption);

    return axios.post(`/user/team/${team_id}/video/${video}`, formData);
  }

  postSlideshowResponse(team_id, slideshow, media, caption) {
    let formData = new FormData();
    formData.append("media", media);
    formData.append("content", caption);

    return axios.post(`/user/team/${team_id}/slideshow/${slideshow}`, formData);
  }

  createStatusPost(team_id, payload) {
    let data = {
      content: payload.content,
    };

    if (payload.attachment) {
      data.media = payload.media;
    }

    if (!payload.attachment) {
      data.media_type = "text";
      data.media_type_id = 1;
    } else if (payload.attachment.type.includes("image")) {
      data.media_type = "photo";
      data.media_type_id = 2;
    } else if (payload.attachment.type.includes("audio")) {
      data.media_type = "audio";
      data.media_type_id = 4;
    } else if (payload.attachment.type.includes("video")) {
      data.media_type = "video";
      data.media_type_id = 3;
    } else if (
      payload.attachment.type.includes("application") ||
      payload.attachment.type.includes("text")
    ) {
      data.media_type = "document";
      data.media_type_id = 5;
    }

    if (payload.avatarMedia) {
      data.media = payload.avatarMedia;
      data.media_type = "video";
      data.media_type_id = 3;
    }

    if (payload.summary) {
      data.summary = payload.summary;
    }

    return axios.post(`/user/team/${team_id}/posts`, data);
  }

  // createTextPost(team_id, content) {
  //   return axios.post(`/user/team/${team_id}/posts`, {
  //     content,
  //     media_type: "text",
  //   });
  // }

  postChangeUserRole(team_id, user_id, role_id) {
    return axios.post(`/user/team/${team_id}/change-user-role`, {
      user_id: user_id,
      role_id: role_id,
    });
  }

  postRemindSlideshow(team_id, slideshow_id, user_id) {
    return axios.post(
      `/user/team/${team_id}/slideshow/${slideshow_id}/user/${user_id}/response-reminder`
    );
  }

  postRemindTeamVideo(team_id, teamVideo_id, user_id) {
    return axios.post(
      `/user/team/${team_id}/video/${teamVideo_id}/user/${user_id}/response-reminder`
    );
  }

  createCelebration(team_id, payload) {
    let data = {
      color_id: payload.color_id,
      text: payload.text,
      intro_video_id: payload.intro_video_id,
      outro_video_id: payload.outro_video_id,
    };

    if (payload.attachment) {
      data.media = payload.media;
    }

    if (payload.tag_users) {
      data.tag_users = payload.tag_users;
    }

    if (!payload.attachment) {
      data.media_type = "text";
      data.media_type_id = 1;
    } else if (payload.attachment.type.includes("image")) {
      data.media_type = "photo";
      data.media_type_id = 2;
    } else if (payload.attachment.type.includes("audio")) {
      data.media_type = "audio";
      data.media_type_id = 4;
    } else if (payload.attachment.type.includes("video")) {
      data.media_type = "video";
      data.media_type_id = 3;
    } else if (
      payload.attachment.type.includes("application") ||
      payload.attachment.type.includes("text")
    ) {
      data.media_type = "document";
      data.media_type_id = 5;
    }
    if (payload.introOutroSelected) {
      data.media_type = "video";
      data.media_type_id = 3;
    }
    return axios.post(`/user/team/${team_id}/celebration`, data);
  }

  createBrightidea(team_id, payload) {
    let data = {
      color_id: payload.color_id,
      text: payload.text,
    };

    if (payload.attachment) {
      data.media = payload.media;
    }

    if (payload.tag_users) {
      data.tag_users = payload.tag_users;
    }

    if (!payload.attachment) {
      data.media_type = "text";
      data.media_type_id = 1;
    } else if (payload.attachment.type.includes("image")) {
      data.media_type = "photo";
      data.media_type_id = 2;
    } else if (payload.attachment.type.includes("audio")) {
      data.media_type = "audio";
      data.media_type_id = 4;
    } else if (payload.attachment.type.includes("video")) {
      data.media_type = "video";
      data.media_type_id = 3;
    } else if (
      payload.attachment.type.includes("application") ||
      payload.attachment.type.includes("text")
    ) {
      data.media_type = "document";
      data.media_type_id = 5;
    }

    if (payload.avatarMedia) {
      data.media = payload.avatarMedia;
      data.media_type = "video";
      data.media_type_id = 3;
    }

    if (payload.summary) {
      data.summary = payload.summary;
    }

    return axios.post(`/user/team/${team_id}/brightidea`, data);
  }

  createCheckIn(team_id) {
    return axios.post(`/user/team/${team_id}/checkin`);
  }

  reactToListTask(team_id, list_id, list_task_id, buzz_type_id) {
    return axios.post(
      `/user/team/${team_id}/todo-list/${list_id}/todo-list-item/${list_task_id}/buzz?buzz_type_id=${buzz_type_id}`
    );
  }

  reactToPost(team_id, post_id, buzz_type_id) {
    return axios.post(
      `/user/team/${team_id}/post/${post_id}/buzz?buzz_type_id=${buzz_type_id}`
    );
  }

  reactToCompanyPost(company_id, post_id, buzz_type_id) {
    return axios.post(
      `/company/${company_id}/post/${post_id}/buzz?buzz_type_id=${buzz_type_id}`
    );
  }


  clearPostReaction(team_id, post_id) {
    return axios.delete(`/user/team/${team_id}/post/${post_id}/buzz`);
  }

  clearCompanyPostReaction(company_id, post_id) {
    return axios.delete(`/company/${company_id}/post/${post_id}/buzz`);
  }

  clearTodoReaction(team_id, list_id, list_task_id) {
    return axios.delete(
      `/user/team/${team_id}/todo-list/${list_id}/todo-list-item/${list_task_id}/buzz`
    );
  }

  getSinglePost(team_id, post_id) {
    return axios.get(`/user/team/${team_id}/posts/${post_id}`);
  }

  getSingleCompanyPost(companyId, postId) {
    return axios.get(`company/${companyId}/posts/${postId}`);
  }

  getUserDashboard(team_id) {
    return axios.get(`/user/team/${team_id}/dashboard`);
  }

  getExpressionList(team_id, post_id, paramData) {
    return axios.get(`/user/team/${team_id}/post/${post_id}/expression`, {
      params: {
        ...paramData,
      },
    });
  }

  getCompanyExpressionList(company_id, post_id, paramData) {
    return axios.get(`/company/${company_id}/post/${post_id}/expression`, {
      params: {
        ...paramData,
      },
    });
  }

  getSingleExpression(team_id, post_id, expression_id) {
    return axios.get(
      `/user/team/${team_id}/post/${post_id}/expression/${expression_id}`
    );
  }

  getSingleCompanyExpression(company_id, post_id, expression_id) {
    return axios.get(
      `/company/${company_id}/post/${post_id}/expression/${expression_id}`
    );
  }
  

  getSingleList(team_id, list_id) {
    return axios.get(`/user/team/${team_id}/todo-list/${list_id}`);
  }

  getSingleListItem(team_id, list_id, listTask_id) {
    return axios.get(
      `/user/team/${team_id}/todo-list/${list_id}/todo-list-item/${listTask_id}`
    );
  }

  getSingleListItemExpression(team_id, list_id, listTask_id, expression_id) {
    return axios.get(
      `/user/team/${team_id}/todo-list/${list_id}/todo-list-item/${listTask_id}/expression/${expression_id}`
    );
  }

  getListTaskExpressions(team_id, list_id, list_task_id, paramData) {
    return axios.get(
      `/user/team/${team_id}/todo-list/${list_id}/todo-list-item/${list_task_id}/expression`,
      {
        params: {
          ...paramData,
        },
      }
    );
  }

  createPostExpression(team_id, post_id, payload, paramData) {
    let data = {};
    if (payload.comment) {
      data = {
        content: payload.comment,
      };
    }

    if (payload.attachment) {
      data.media = payload.media;
      data.media_name = payload.attachment.name;
    }
    if (!payload.attachment) {
      data.media_type = "text";
      data.media_type_id = 1;
    } else if (payload.attachment.type.includes("image")) {
      data.media_type = "photo";
      data.media_type_id = 2;
    } else if (payload.attachment.type.includes("audio")) {
      data.media_type = "audio";
      data.media_type_id = 4;
    } else if (payload.attachment.type.includes("video")) {
      data.media_type = "video";
      data.media_type_id = 3;
    } else if (
      payload.attachment.type.includes("application") ||
      payload.attachment.type.includes("text")
    ) {
      data.media_type = "document";
      data.media_type_id = 5;
    }
    return axios.post(
      `/user/team/${team_id}/post/${post_id}/expression`,
      data,
      { params: { ...paramData } }
    );
  }

  createCompanyPostExpression(company_id, post_id, payload, paramData) {
    let data = {};
    if (payload.comment) {
      data = {
        content: payload.comment,
      };
    }

    if (payload.attachment) {
      data.media = payload.media;
      data.media_name = payload.attachment.name;
    }
    if (!payload.attachment) {
      data.media_type = "text";
      data.media_type_id = 1;
    } else if (payload.attachment.type.includes("image")) {
      data.media_type = "photo";
      data.media_type_id = 2;
    } else if (payload.attachment.type.includes("audio")) {
      data.media_type = "audio";
      data.media_type_id = 4;
    } else if (payload.attachment.type.includes("video")) {
      data.media_type = "video";
      data.media_type_id = 3;
    } else if (
      payload.attachment.type.includes("application") ||
      payload.attachment.type.includes("text")
    ) {
      data.media_type = "document";
      data.media_type_id = 5;
    }
    return axios.post(
      `/company/${company_id}/post/${post_id}/expression`,
      data,
      { params: { ...paramData } }
    );
  }

  reactToPostComment(team_id, post_id, expression_id, buzz_type_id) {
    return axios.post(
      `/user/team/${team_id}/post/${post_id}/expression/${expression_id}/buzz?buzz_type_id=${buzz_type_id}`
    );
  }

  reactToCompanyPostComment(company_id, post_id, expression_id, buzz_type_id) {
    return axios.post(
      `/company/${company_id}/post/${post_id}/expression/${expression_id}/buzz?buzz_type_id=${buzz_type_id}`
    );
  }

  reactToTaskComment(team_id, list_id, expression_id, buzz_type_id) {
    return axios.post(
      `/user/team/${team_id}/todo-list-item/${list_id}/expression/${expression_id}/buzz?buzz_type_id=${buzz_type_id}`
    );
  }

  clearCompanyCommentReaction(company_id, post_id, expression_id) {
    return axios.delete(
      `/company/${company_id}/post/${post_id}/expression/${expression_id}/buzz`
    );
  }

  clearCommentReaction(team_id, post_id, expression_id) {
    return axios.delete(
      `/user/team/${team_id}/post/${post_id}/expression/${expression_id}/buzz`
    );
  }

  clearTaskCommentReaction(team_id, list_id, expression_id) {
    return axios.post(
      `/user/team/${team_id}/todo-list-item/${list_id}/expression/${expression_id}/buzz`
    );
  }

  getListCommentExpressions(
    team_id,
    list_id,
    list_task_id,
    page,
    expression_id
  ) {
    return axios.get(
      `/user/team/${team_id}/todo-list/${list_id}/todo-list-item/${list_task_id}/expression?parent_expression_id=${expression_id}`,
      {
        params: {
          page,
        },
      }
    );
  }

  createListTaskExpression(team_id, list_id, list_task_id, payload, paramData) {
    let data = {};
    if (payload.comment) {
      data = {
        content: payload.comment,
      };
    }

    if (payload.attachment) {
      data.media = payload.media;
      data.media_name = payload.attachment.name;
    }
    if (!payload.attachment) {
      data.media_type = "text";
      data.media_type_id = 1;
    } else if (payload.attachment.type.includes("image")) {
      data.media_type = "photo";
      data.media_type_id = 2;
    } else if (payload.attachment.type.includes("audio")) {
      data.media_type = "audio";
      data.media_type_id = 4;
    } else if (payload.attachment.type.includes("video")) {
      data.media_type = "video";
      data.media_type_id = 3;
    } else if (
      payload.attachment.type.includes("application") ||
      payload.attachment.type.includes("text")
    ) {
      data.media_type = "document";
      data.media_type_id = 5;
    }

    return axios.post(
      `/user/team/${team_id}/todo-list/${list_id}/todo-list-item/${list_task_id}/expression`,
      data,
      { params: { ...paramData } }
    );
  }

  getTeamTopic(team_id) {
    return axios.get(`/user/team/${team_id}/topic-of-day`);
  }

  createTeamTopic(team_id, content) {
    return axios.post(`/user/team/${team_id}/topic`, {
      content,
    });
  }

  updateTeamTopic(team_id, topic_id, content) {
    return axios.put(`/user/team/${team_id}/topic/${topic_id}`, {
      content,
    });
  }

  getCheckInStats(team_id, from_date) {
    return axios.get(`/user/team/${team_id}/checkin/metrics`, {
      params: {
        from_date,
      },
    });
  }

  getCheckInLatestData(team_id) {
    return axios.get(`/user/team/${team_id}/checkin`);
  }

  getCheckInStatsDetails(team_id, from_date) {
    return axios.get(`/user/team/${team_id}/checkin/metrics/detail`, {
      params: {
        from_date,
      },
    });
  }

  deleteMyTeam(team_id) {
    return axios.delete(`/user/team/${team_id}`);
  }

  postCheckInResponse(team_id, checkin_id, mood_id, privateMood) {
    return axios.post(`/user/team/${team_id}/checkin/${checkin_id}`, {
      mood_id: mood_id,
      private: privateMood,
    });
  }

  getTeamVideoStats(team_id, from_date) {
    return axios.get(`/user/team/${team_id}/videos/metrics`, {
      params: {
        from_date,
      },
    });
  }

  postShare(team_id, post_id, team_ids, innovation_share) {
    const { isCompany, isInnovationTeam, is_innovative_team, company } = innovation_share;

    let data = {
      team_ids,
    }

    if(isInnovationTeam || isCompany) {
      data.share_in_company = isCompany
      data.share_in_innovation_team = isInnovationTeam
      data.show_user_details_in_company = !company
      data.show_user_details_in_innovation_team = !is_innovative_team
    }

    if (innovation_share.include_expressions) {
      data.include_expressions = true;
    }

    return axios.post(`/user/team/${team_id}/posts/${post_id}/share`, {
      ...data
    });
  }

  getInnovistaCompanyTimeline(companyId, page) {
    return axios.get(`/company/${companyId}/timeline`,  {
      params: {
        page,
      },
    });
  }

  postCreateTodoList(team_id, name) {
    return axios.post(`/user/team/${team_id}/todo-list`, name);
  }

  shareTodoList(team_id, list_id, data) {
    return axios.post(`/user/team/${team_id}/todo-list/${list_id}/share`, data);
  }

  shareTodoListItem(team_id, list_id, list_item_id, data) {
    return axios.post(
      `/user/team/${team_id}/todo-list/${list_id}/todo-list-item/${list_item_id}/share`,
      data
    );
  }

  getTodoList(team_id, page) {
    return axios.get(`/user/team/${team_id}/todo-list`, {
      params: {
        page,
      },
    });
  }

  updateTodoListTask(team_id, list_id, task_id, payload) {
    return axios.put(
      `/user/team/${team_id}/todo-list/${list_id}/todo-list-item/${task_id}`,
      payload
    );
  }

  updateTodoList(team_id, list_id, name) {
    return axios.put(`/user/team/${team_id}/todo-list/${list_id}`, name);
  }

  getTodoListAllTask(team_id, todoList_id, page, order_by, status_id) {
    return axios.get(
      `/user/team/${team_id}/todo-list/${todoList_id}/timeline`,
      {
        params: {
          page,
          order_by,
          status_id,
        },
      }
    );
  }

  getAllTeamMembers() {
    return axios.get("/user/team-members");
  }

  postTodoTask(team_id, todoList_id, payload) {
    let data = {
      text: payload.text,
      description: payload.description,
      priority: payload.priority,
      due_date: payload.due_date,
    };

    if (payload.attachment) {
      data.media = payload.media;
    }

    if (payload.tag_users) {
      data.tag_users = payload.tag_users;
    }

    if (!payload.attachment) {
      data.media_type = "text";
      data.media_type_id = 1;
    } else if (payload.attachment.type.includes("image")) {
      data.media_type = "photo";
      data.media_type_id = 2;
    } else if (payload.attachment.type.includes("audio")) {
      data.media_type = "audio";
      data.media_type_id = 4;
    } else if (payload.attachment.type.includes("video")) {
      data.media_type = "video";
      data.media_type_id = 3;
    }
    return axios.post(
      `/user/team/${team_id}/todo-list/${todoList_id}/todo-list-item`,
      data
    );
  }

  getSlidshowStats(team_id, from_date) {
    return axios.get(`/user/team/${team_id}/slideshows/metrics`, {
      params: {
        from_date,
      },
    });
  }

  getRecognitionStats(team_id, from_date) {
    return axios.get(`/user/team/${team_id}/celebration/metrics`, {
      params: {
        from_date,
      },
    });
  }

  getRecognitionStatsDetails(team_id, from_date, page) {
    return axios.get(`/user/team/${team_id}/celebration/metrics/detail`, {
      params: {
        from_date,
        page,
      },
    });
  }

  getSlideshowStatsDetails(team_id, from_date, page) {
    return axios.get(`/user/team/${team_id}/slideshows`, {
      params: {
        from_date,
        page,
      },
    });
  }
  publishTeamVideo(team_id, video_id) {
    return axios.post(`/user/team/${video_id}/video/${team_id}/publish`);
  }
  publishSlideShow(team_id, slideshow_id) {
    return axios.post(
      `/user/team/${slideshow_id}/slideshow/${team_id}/publish`
    );
  }

  getSlideShow(team_id, slideshow) {
    return axios.get(`/user/team/${team_id}/slideshow/${slideshow}`);
  }
  getSlideShowResponse(team_id, slideshow) {
    return axios.get(`/user/team/${team_id}/slideshows/${slideshow}`);
  }
  getNetThrivingScoreStats(team_id, from_date) {
    return axios.get(`/user/team/${team_id}/stats`, {
      params: {
        from_date,
      },
    });
  }
  getNetThrivingScoreStatsDetails(team_id, from_date) {
    return axios.get(`/user/team/${team_id}/members/stats`, {
      params: {
        from_date,
      },
    });
  }

  createTodoFromActionItems(data) {
    return axios.post(`ai-service/todo-generator`, data, {
      headers: WellnessHeaders,
    });
  }

  updateSummaryIntoPost(teamId, postId, data) {
    return axios.put(`user/team/${teamId}/posts/${postId}`, data);
  }

  generiaAIGen(data) {
    return axios.post(`ai-service/generia-ai-gen`, data, {
      headers: WellnessHeaders,
    });
  }

  getAiTutorResp(data) {
    return axios.post(`ai-service/ai-tutor`, data, {
      headers: WellnessHeaders,
    });
  }
}

export default new TeamService();
